const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please try again later.";

export default DEFAULT_ERROR_MESSAGE;
